import { IStore } from '../../../common/store';
import { TSectionsKeys } from '../../model/IStoreTypes';

const customiseSelectors = {
  getSpecificationsFeaturesModal: (state: IStore) =>
    state.customiseCombinedReducer.customiseReducer.specificationsFeaturesModal,
  getCurrentSelectedPostcode: (state: IStore) => state.customiseCombinedReducer.customiseReducer.postcode,
  getIsSecondaryCurrencyDisplay: (state: IStore) =>
    state.customiseCombinedReducer.customiseReducer.isSecondaryCurrencyDisplay,
};

export default customiseSelectors;

export const getCustomiseSections = (state: IStore) => state.customiseCombinedReducer.customiseReducer.sections;
export const getCustomiseSection = (state: IStore, name: TSectionsKeys) =>
  state.customiseCombinedReducer.customiseReducer.sections[name];
export const getCustomiseSelectedSection = (state: IStore) =>
  state.customiseCombinedReducer.customiseReducer.selectedSection;
